import { motion } from "framer-motion";

export const LUX_EASE = [0.22, 1, 0.36, 1];

export default function Reveal({
  children,
  delay = 0,
  y = 36,
  className = "",
  once = true,
}) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: LUX_EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-3 text-[11px] sm:text-xs font-sans font-medium uppercase tracking-luxe text-gold ${className}`}
    >
      <span className="h-px w-8 bg-gold/60" aria-hidden="true" />
      {children}
    </span>
  );
}
